import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_long-arrow-right",
  "use": "icon_long-arrow-right-usage",
  "viewBox": "0 0 20 10",
  "content": "<symbol viewBox=\"0 0 20 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_long-arrow-right\"><path d=\"M14.0152 3.21422H0.535713C0.239866 3.21422 0 3.45408 0 3.74993V6.24993C0 6.54577 0.239866 6.78564 0.535713 6.78564H14.0152V8.84184C14.0152 9.79639 15.1693 10.2744 15.8443 9.59947L19.6862 5.75756C20.1046 5.33913 20.1046 4.66073 19.6862 4.24234L15.8443 0.400429C15.1693 -0.274525 14.0152 0.20351 14.0152 1.15806V3.21422Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol